import { render } from "./DisabilityConfirmationPage.vue?vue&type=template&id=7c254f26&scoped=true"
import script from "./DisabilityConfirmationPage.vue?vue&type=script&lang=js"
export * from "./DisabilityConfirmationPage.vue?vue&type=script&lang=js"

import "./DisabilityConfirmationPage.vue?vue&type=style&index=0&id=7c254f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c254f26"]])

export default __exports__